





















import { Vue, Component, Prop } from 'nuxt-property-decorator';
import RemoveIcon from '@/components/common/UniversalSearch/images/times.vue.svg';

@Component<UniversalSearchResultsItem>({
  components: {
    RemoveIcon,
  },
})
export default class UniversalSearchResultsItem extends Vue {
  @Prop({ default: false }) removable!: boolean;

  // if event was on a link inside - pass that info to the parent
  handleClick(event: Event) {
    let fromLink = false;
    if (typeof event.composedPath !== 'undefined') {
      const path = event.composedPath();
      const isRemoveClicked = path.some(
        el => el instanceof HTMLElement && el.classList.contains('universal-search-results-item__action'),
      );

      if (isRemoveClicked) {
        return;
      }

      fromLink = path.some(el => el instanceof HTMLAnchorElement);
    }
    this.$emit('open', { willOpen: !fromLink });
  }
}
